var storage = {
  getSessionData: async function() {
    // check to see if localStorage contains required session data (DNI)
    var key = Object.keys(localStorage);
    var requiredKeys = ['referrer_and_dni', 'dni', 'gclid'];
    var matchingKeys = key.filter(element => requiredKeys.indexOf(element) !== -1);

    if (!localStorage.length || (matchingKeys.length !== requiredKeys.length)) {
      $.ajax({
        dataType: 'json',
        url: "/get-session-data/",
        data: {'property_id': jcms.property.property_id},
        success: function(data, status) {
          if (status === 'success') {
            for (key in data) {
              if (!data[key]) { continue; }
              if (typeof data[key] == 'object') {
                localStorage.setItem(key, JSON.stringify(data[key]));
              }
              else {
                localStorage.setItem(key, data[key]);
              }
            }
          }
        }
      });
    }

    // Set gclid into saved_form_data
    var gclid = localStorage.getItem('gclid');
    if (gclid) {
      var formData = storage.get('saved_form_data');
      if (formData) {
        formData.gclid = gclid;
        storage.set('saved_form_data', formData);
      }
      else {
        storage.set('saved_form_data', {'gclid': gclid});
      }
    }
  },

  getBlackboxTimestamp: async function() {
    // get cache file modified time
    $.ajax({
      url: "/get-blackbox/",
      method: "POST",
      dataType: 'json',
      data: {
        'timestamp': true,
        'property_id': jcms.property.property_id
      },
      success: function(data, status) {
        if (status === 'success') {
          // get blackbox data
          storage.getBlackboxData(data);
        }
      }
    });
  },

  getBlackboxData: async function(timestamp) {
    if (!timestamp) { return; }

    var bGetData = false;
    if (!localStorage.getItem('blkbxmtime_' + jcms.property.property_id) || !localStorage.getItem('property_cache_' + jcms.property.property_id)) { bGetData = true; }
    if (+localStorage.getItem('blkbxmtime_' + jcms.property.property_id) < timestamp) { bGetData = true; }
    if (localStorage.getItem('blkbxmtime_' + jcms.property.property_id) == 'undefined') { bGetData = true; }

    if (bGetData) {
      $.ajax({
        url: "/get-blackbox/",
        method: "POST",
        dataType: 'json',
        data: {
          'get_apartments': true,
          'property_id': jcms.property.property_id,
          'property_name': jcms.property.name
        },
        success: function(data, status) {
          if (status === 'success') {
            storage.set('property_cache_' + jcms.property.property_id, data);
            // reset timestamp
            storage.set('blkbxmtime_' + jcms.property.property_id, timestamp);
          }
        }
      });
    }
  },

  set: function(name, value) {
    if (typeof name == 'undefined' || !name.length || typeof value == 'undefined') { return false; }

    if (typeof value === 'string') {
      localStorage.setItem(name, value);
    }
    else {
      localStorage.setItem(name, JSON.stringify(value));
    }
  },

  get: function(name) {
    let data = [];
    for (let [key, value] of Object.entries(localStorage)) {
      data[key] = isJson(value) ? JSON.parse(value) : value;
    }
    if (typeof name != 'undefined' && name.length) {
      return data[name];
    }
    return false;
  },

  delete: function(name) {
    if (typeof name == 'undefined' || !name.length) { return; }

    delete storageData[name];
    localStorage.removeItem(name);
  },

  ready: function() {
    this.getSessionData();
    this.getBlackboxTimestamp();
  }
};

$(function() { storage.ready(); });
